module.exports = __webpack_public_path__ + "static/Book3-a6c3cf22e1878b93e830ac4aca58c59e.jpg";